import { CustomHeader } from "components/universal/custom-header";
import { useUser } from "hooks/useUser";
import { useTranslation } from "react-i18next";
import { UnauthorizedUser } from "views/disinfection-techniques/unauthorized-user";
import { EmployeeManagementView } from "views/employee-management";

export const EmployeeManagement = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'SEO.employeeManagement',
    });
    const { isAuthenticated } = useUser();

    if (!isAuthenticated) {
        return <UnauthorizedUser />;
    }

    return (
        <div>
            <CustomHeader title={t('title')} />
            <EmployeeManagementView />
        </div>
    );
};
